import React from 'react';

export const urgencies = [
    {id: 0, value: "Low", ucl: 'signal-info' },
    {id: 1, value: "Normal", ucl: 'signal-close'},
    {id: 2, value: "Medium", ucl: 'signal-inpro'},
    {id: 3, value: "High", ucl: 'signal-wrn'},
    {id: 4, value: "Very High", ucl: 'signal-unatd'},
];